import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { SorteeLandingPage } from './sorteeLanding/SorteeLandingPage'

const SORTEE_LANDING_SCOPE_CLASS = 'sortee-landing-active'

function activateSorteeLandingScope(): void {
  document.documentElement.classList.add(SORTEE_LANDING_SCOPE_CLASS)
  document.body.classList.add(SORTEE_LANDING_SCOPE_CLASS)
  document.getElementById('root')?.classList.add(SORTEE_LANDING_SCOPE_CLASS)
}

function deactivateSorteeLandingScope(): void {
  document.documentElement.classList.remove(SORTEE_LANDING_SCOPE_CLASS)
  document.body.classList.remove(SORTEE_LANDING_SCOPE_CLASS)
  document.getElementById('root')?.classList.remove(SORTEE_LANDING_SCOPE_CLASS)
}

export function IndexPage() {
  const { hash } = useLocation()
  useEffect(() => {
    const frame = requestAnimationFrame(() => {
      if (hash) document.getElementById(hash.slice(1))?.scrollIntoView()
      else window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
    })
    return () => cancelAnimationFrame(frame)
  }, [hash])
  useEffect(() => {
    activateSorteeLandingScope()

    return () => {
      deactivateSorteeLandingScope()
    }
  }, [])

  return <SorteeLandingPage />
}
